import { Toaster } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import NotFound from "@/pages/NotFound";
import { Route, Switch } from "wouter";
import ErrorBoundary from "./components/ErrorBoundary";
import { ThemeProvider } from "./contexts/ThemeContext";
import AdminDashboardPage from "./pages/admin/AdminDashboard";
import AdminMembersPage from "./pages/admin/AdminMembers";
import {
  AdminOrderDetailPage,
  AdminOrdersListPage,
} from "./pages/admin/AdminOrders";
import AdminProductsPage from "./pages/admin/AdminProducts";
import AdminAiDebugPage from "./pages/admin/AdminAiDebug";
import {
  AdminInquiriesListPage,
  AdminInquiryDetailPage,
} from "./pages/admin/AdminInquiries";
import CheckoutPage from "./pages/Checkout";
import Home from "./pages/Home";
import MyPage from "./pages/MyPage";
import OptionsPage from "./pages/Options";
import OrderCompletePage from "./pages/OrderComplete";
import OrderDetailPage from "./pages/OrderDetail";
import OrderPage from "./pages/Order";
import CheckoutV1Page from "./pages/CheckoutV1";
import CreatePage from "./pages/Create";
import InquiryNewPage from "./pages/InquiryNew";
import SupportPage from "./pages/Support";

function Router() {
  return (
    <Switch>
      <Route path="/" component={Home} />
      <Route path="/order" component={OrderPage} />
      {/* /create renders the artDirector.analyze/generateSmart (PRECISE_EDIT/
          ART_TRANSFORM) flow. This used to hard-redirect to /order in
          production while the AI pipeline was still being verified; that's
          done now (real Google-authenticated E2E runs succeeded), so it's
          a normal route here. Access control is unchanged: CreatePage's own
          effect sends unauthenticated visitors to Google login, and every
          mutation it calls (analyze/generateSmart/uploadReference/
          listSession) is still protectedProcedure server-side regardless of
          what the frontend route does — this is a routing change only, not
          an auth change. */}
      <Route path="/create" component={CreatePage} />
      <Route path="/options" component={OptionsPage} />
      <Route path="/checkout" component={CheckoutPage} />
      <Route path="/checkout-v1" component={CheckoutV1Page} />
      <Route path="/order-complete" component={OrderCompletePage} />
      <Route path="/my" component={MyPage} />
      <Route path="/support" component={SupportPage} />
      <Route path="/inquiry/new" component={InquiryNewPage} />
      <Route path="/orders/:id" component={OrderDetailPage} />

      <Route path="/admin" component={AdminDashboardPage} />
      <Route path="/admin/orders" component={AdminOrdersListPage} />
      <Route path="/admin/orders/:id" component={AdminOrderDetailPage} />
      <Route path="/admin/products" component={AdminProductsPage} />
      <Route path="/admin/members" component={AdminMembersPage} />
      <Route path="/admin/inquiries" component={AdminInquiriesListPage} />
      <Route path="/admin/inquiries/:id" component={AdminInquiryDetailPage} />
      <Route path="/admin/ai-debug" component={AdminAiDebugPage} />

      <Route path="/404" component={NotFound} />
      <Route component={NotFound} />
    </Switch>
  );
}

function App() {
  return (
    <ErrorBoundary>
      <ThemeProvider defaultTheme="light">
        <TooltipProvider>
          <Toaster />
          <Router />
        </TooltipProvider>
      </ThemeProvider>
    </ErrorBoundary>
  );
}

export default App;
